import React, {
  createContext,
  Dispatch,
  ReactElement,
  SetStateAction,
  useEffect,
  useState,
} from "react";
import { Box } from "../entities/box.entity";
import { Item } from "../entities/item.entity";
import { getUserNameFromToken } from "../common/get_user_name";

interface AppContextInterface {
  currentUserName: string;
  currentTab: number;
  loading: boolean;
  box: Box | undefined;
  item: Item | undefined;
  showCLModal: boolean;
  showADModal: boolean;
  itemSearchExternal: string;
  setCurrentTab: Dispatch<SetStateAction<number>>;
  setLoading: Dispatch<SetStateAction<boolean>>;
  setBox: Dispatch<SetStateAction<Box | undefined>>;
  setItem: Dispatch<SetStateAction<Item | undefined>>;
  setShowCLModal: Dispatch<SetStateAction<boolean>>;
  setShowADModal: Dispatch<SetStateAction<boolean>>;
  setItemSearchExternal: Dispatch<SetStateAction<string>>;
  setCurrentUserName: Dispatch<SetStateAction<string>>;
}

//initialize expmty context
export const Context = createContext<AppContextInterface>({
  currentUserName: "",
  currentTab: 0,
  loading: false,
  showCLModal: false,
  showADModal: false,
  box: undefined,
  item: undefined,
  itemSearchExternal: "",
  setCurrentTab: () => ({}),
  setLoading: () => ({}),
  setBox: () => ({}),
  setItem: () => ({}),
  setShowCLModal: () => ({}),
  setShowADModal: () => ({}),
  setItemSearchExternal: () => ({}),
  setCurrentUserName: () => ({}),
});

export function AppContextProvider({ children }: { children: ReactElement }) {
  const [loading, setLoading] = useState<boolean>(false);
  const [currentTab, setCurrentTab] = useState<number>(0);
  const [currentUserName, setCurrentUserName] = useState<string>("");
  const [itemSearchExternal, setItemSearchExternal] = useState<string>("");
  const [showCLModal, setShowCLModal] = useState<boolean>(false); //change location modal
  const [showADModal, setShowADModal] = useState<boolean>(false); //change location modal
  const [box, setBox] = useState<Box>(); //change location modal
  const [item, setItem] = useState<Item>(); //change location modal

  useEffect(() => {
    if (!currentUserName) {
      setCurrentUserName(getUserNameFromToken());
    }
  });

  return (
    <>
      <Context.Provider
        value={{
          currentTab,
          loading,
          box,
          item,
          showCLModal,
          showADModal,
          itemSearchExternal,
          currentUserName,
          setCurrentTab,
          setLoading,
          setBox,
          setItem,
          setShowCLModal,
          setShowADModal,
          setItemSearchExternal,
          setCurrentUserName,
        }}
      >
        {children}
      </Context.Provider>
    </>
  );
}
